import classnames from 'classnames'
import * as React from 'react'
import type {OmitStrict} from 'type-zoo'
import type {TSkin} from '~/game/skins'
import {skins} from '~/game/skins'
import type {AnyCard} from '~/models/game/types'
import styles from './styles.module.css'

type TImageProps = OmitStrict<
  React.ImgHTMLAttributes<HTMLImageElement>,
  'src' | 'className'
>

export interface IGameCardProps extends TImageProps {
  model: AnyCard
  invert: boolean
  skin: TSkin
  className?: string
  // NB: we avoid adding rounding to cards that already have some built-in
  forceRoundedCornersOnSharpCornerSkins?: boolean
}

const CardImage = (props: IGameCardProps) => {
  const {
    model,
    invert,
    skin,
    className,
    forceRoundedCornersOnSharpCornerSkins,
    ...imgProps
  } = props
  return (
    <img
      alt={`Card: ${model.type}`}
      {...imgProps}
      className={classnames(
        styles.cardImage,
        forceRoundedCornersOnSharpCornerSkins &&
          skins[skin].cardsHaveSharpCorners &&
          styles.roundedCorners,
        className,
        invert && styles.upsideDown
      )}
      src={model.imagePath(skin)}
    />
  )
}

export default CardImage

interface IGameCardBackProps extends TImageProps {
  skin: TSkin
  className?: string
  // NB: we avoid adding rounding to cards that already have some built-in
  forceRoundedCornersOnSharpCornerSkins?: boolean
}

export const CardBackImage = (props: IGameCardBackProps) => {
  const {skin, className, forceRoundedCornersOnSharpCornerSkins, ...imgProps} = props
  return (
    <img
      alt="Card back"
      {...imgProps}
      className={classnames(
        styles.cardImage,
        forceRoundedCornersOnSharpCornerSkins &&
          skins[skin].cardsHaveSharpCorners &&
          styles.roundedCorners,
        className
      )}
      src={`/cards/${skin}/${skins[skin].backOfCardFilename}`}
    />
  )
}
